// Environment configuration for production
// Update backendUrl to point to your live API endpoint
export const environment = {
  production: true,
  apiUrl: '/api',
  backendUrl: '/api',
  firebaseConfig: {
    apiKey: "AIzaSyD1orvsN7Wou1uHj2YfndNCIkTyGvLZJro",
    authDomain: "finspire-6dd67.firebaseapp.com",
    projectId: "finspire-6dd67",
    storageBucket: "finspire-6dd67.firebasestorage.app",
    messagingSenderId: "715130500480",
    appId: "1:715130500480:web:fd09f1dd566f8ccef93d65",
    measurementId: "G-GQWPN3WN4S"
  },
  cloudinary: {
    cloudName: 'dc7gkgjja',
    uploadPreset: 'finspire_projects'
  }
};
